import { createSelector } from 'reselect'

const segmentSelector = ({ segment }) => segment

export const identifyOptionsSelector = createSelector(
  segmentSelector,
  ({ identify_options: identifyOptions }) => identifyOptions
)

export const defaultDomainSelector = createSelector(
  segmentSelector,
  ({ default_domain: defaultDomain }) => defaultDomain || ''
)
